import { Card, Tabs } from 'antd'
import { useEffect, useState } from 'react'
import { AiFillLock } from 'react-icons/ai'
import { HiUser } from 'react-icons/hi'
import { MdOutlineLightbulb } from 'react-icons/md'

import { classNames } from '@/Ship/Helpers/classNames'

import { ProfileManager } from '../../Stores/ProfileManager'

import { ChangePassword } from './ChangePassword'
import { Interface } from './Interface'
import { PersonalInfo } from './PersonalInfo'
import styles from './UserProfile.module.css'

import type { ReactNode } from 'react'

/** До цієї ширини вкладки стоять згори, як у легасі. */
const NARROW_QUERY = '(max-width: 1024px)'

const useIsNarrow = (): boolean => {
    const [isNarrow, setIsNarrow] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(NARROW_QUERY).matches : false
    )

    useEffect(() => {
        const media = window.matchMedia(NARROW_QUERY)
        const update = () => setIsNarrow(media.matches)

        media.addEventListener('change', update)

        return () => media.removeEventListener('change', update)
    }, [])

    return isNarrow
}

const label = (icon: ReactNode, text: string) => (
    <span className={classNames(styles['tabLabel'])}>
        <span className={classNames(styles['tabIcon'])}>{icon}</span>
        {text}
    </span>
)

/**
 * «Мій профіль» (`SPEC-005` §7.3): «Персональна інформація», «Змінити
 * пароль», «Інтерфейс».
 *
 * Вкладки «Сповіщення» немає (ВП-2, Q14.9): її єдиний перемикач «Дублювати
 * сповіщення на e-mail» бек не читає, а email-копій на етапі 1 немає — він
 * обіцяв би неіснуючу механіку.
 */
export const UserProfile = () => {
    const [manager] = useState(() => new ProfileManager())
    const isNarrow = useIsNarrow()

    return (
        <Card className={classNames(styles['card'])}>
            <Tabs
                className={classNames(styles['tabs'])}
                tabPlacement={isNarrow ? 'top' : 'start'}
                items={[
                    {
                        key: 'personal',
                        label: label(<HiUser />, 'Персональна інформація'),
                        children: <PersonalInfo manager={manager} />,
                    },
                    {
                        key: 'password',
                        label: label(<AiFillLock />, 'Змінити пароль'),
                        children: <ChangePassword manager={manager} />,
                    },
                    {
                        key: 'interface',
                        label: label(<MdOutlineLightbulb />, 'Інтерфейс'),
                        children: <Interface />,
                    },
                ]}
            />
        </Card>
    )
}
